import React, { Component } from "react";
import Logout from "../images/logout.svg";
import Back from "../images/back.svg";
import { NumericFormat } from "react-number-format";
import { Accordion, Card, Form, Modal } from "react-bootstrap";
import { WhisperSpinner } from "react-spinners-kit";
import {
  Series,
  Label,
  Legend,
  Chart,
  ArgumentAxis,
  MinorTick,
  Tick,
  ValueAxis,
  Tooltip as ChartTooltip,
  Size,
  Font,
} from "devextreme-react/chart";
import DatePicker, { DateObject } from "react-multi-date-picker";
import moment from "moment-jalaali";
import momentAsli from "moment";
import "react-multi-date-picker/styles/layouts/mobile.css";
import "react-multi-date-picker/styles/layouts/prime.css";
import "react-multi-date-picker/styles/colors/bluee.css";
import Profilee from "../images/profile.svg";
import Profile from "./Profile";
import momentt from "moment-timezone";
import config from "devextreme/core/config";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import Paginator from "../components/Paginator";
import CustomButton from "../components/CustomButton";
import FacturesReportInfo from "../components/FacturesReportInfo";
import { toast } from "react-toastify";
import fileExcel from "@iconify/icons-la/file-excel";
import searchIcon from "@iconify/icons-la/search";
import baselineClose from "@iconify/icons-ic/baseline-close";
import {
  BaseUrl,
  Authorization,
  BaseUrlPublic,
  isUser,
  LogoutFunction,
} from "../static.js";
import Tooltip from "@mui/material/Tooltip";

config({
  rtlEnabled: true,
});

export default class Reports extends Component {
  constructor(props) {
    super(props);
    this.formatCurrency = this.formatCurrency.bind(this);
    this.state = {
      TotalCreditsCount: 0,
      CurrentCredit: 0,
      GetCredit: 0,
      UsedCredit: 0,
      ExpireCredit: 0,
      showCustomerExtraInfo: false,
      ModalShow: false,
      writingProgress: false,
      dataLoading: true,
      currentPage: 1,
      totalPages: 1,
      chartData: [],
      argumentField: "title",
      valueField: "value",
      chartContainerWidth: 0,
      chartContainerHeight: 0,
      CreditCountParticipant: 0,
      CreditAmountParticipant: 0,
      TotalExpireAmount: 0,
      justTableLoading: false,
      CNameErrorText: "",
      CNameValue: "",
      CPhoneErrorText: "",
      CPhoneValue: "",
      minCreditErrorText: "",
      minCreditValue: "",
      maxCreditErrorText: "",
      maxCreditValue: "",
      ModalShow2: false,
      selectedGroupList: [],
      groupList: [],
      groupListLoading: false,
      tableHasFilter: false,
      ModalShow3: false,
      reportTitle: "",
      detailReportTitle: "",
      modal3Loading: false,
      currentAccountId: null,
      ModalShow4: false,
      resID: "",
      priceUnitValue: "",
      defaultLanguage: "",
      sellReportMode: "daily",
      sellReportCount: 5,
      reportSelected: 0,
      currentValueField: "",
      currentArgumentField: "",
      dateValue2: moment().format("jYYYY/jMM/jDD"),
      dateValue1: moment().add(-1, "months").format("jYYYY/jMM/jDD"),
      maxDateStart: moment().add(-1, "days").format("jYYYY/jMM/jDD"),
      maxDate: moment().add(0, "days").format("jYYYY/jMM/jDD"),
      minDate: moment().add(-1, "months").format("jYYYY/jMM/jDD"),
      report2Data: [],

      gridLocaleText: {
        selectAll: "انتخاب همه",
        selectAllSearchResults: "انتخاب همه نتایج جستجو",
        searchOoo: "جستجو...",
        blanks: "خالی",
        noMatches: "پشدا نشد",
        filterOoo: "فیلتر...",
        equals: "مساوی",
        notEqual: "نا مساوی",
        lessThan: "کمتر از",
        greaterThan: "بیشتر از",
        lessThanOrEqual: "کوچکتر مساوی",
        greaterThanOrEqual: "بزرگتر مساوی",
        inRange: "در محدوده",
        inRangeStart: "به",
        inRangeEnd: "از",
        contains: "شامل",
        notContains: "شامل نباشد",
        startsWith: "شروع با",
        endsWith: "پایان با",
        andCondition: "و",
        orCondition: "یا",
        applyFilter: "تایید",
        resetFilter: "راه اندازی مجدد",
        clearFilter: "پاک کردن",
        cancelFilter: "انصراف",
        columns: "ستون ها",
        filters: "فیلترها",
        group: "گروه",
        loadingOoo: "لطفاً شکیبا باشید...",
        noRowsToShow: "هیچ موردی یافت نشد",
        enabled: "فعال",
        sum: "جمع",
        min: "کمترین",
        max: "بیشترین",
        none: "None",
        count: "تعداد",
        avg: "میانگین",
        filteredRows: "فیلتر شده",
        selectedRows: "انتخاب شده",
        totalRows: "جمع ردیف ها",
        totalAndFilteredRows: "ردیف ها",
        page: "صفحه",
        more: "بیشتر",
        to: "تا",
        of: "از",
        next: "بعدی",
        last: "آخرین",
        first: "اولین",
        previous: "قبلی",
      },
      rowData: [],
      columnDefs: [
        {
          headerName: "نام و نام خانوادگی",
          field: "fullName",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "تلفن همراه",
          field: "mobile",
          // cellRenderer: "formatString",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
            direction: "ltr",
          },
          lockPosition: true,
        },
        {
          headerName: "جمع خرید",
          field: "sum",
          cellRenderer: "formatCurrency",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
      ],
      columnDefs1: [
        {
          headerName: "شماره فاکتور",
          field: "id",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "نام مشتری",
          field: "customerFullName",
          cellRenderer: "formatString",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
            direction: "ltr",
          },
          lockPosition: true,
        },
        {
          headerName: "موبایل مشتری",
          field: "customerMobile",
          cellRenderer: "formatString",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
            direction: "ltr",
          },
          lockPosition: true,
        },
        {
          headerName: "محل سفارش",
          field: "orderStationName",
          cellRenderer: "formatString",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "جزییات سفارش",
          field: "id",
          cellRenderer: "fotmatInfoCell",
          cellRendererParams: {
            showDetails: this.showFactureDetails.bind(this),
          },
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },

        {
          headerName: "مالیات",
          field: "tax",
          cellRenderer: "formatCurrency",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },

        {
          headerName: "حق سرویس",
          field: "service",
          cellRenderer: "formatCurrency",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "هزینه بسته بندی",
          field: "packing",
          cellRenderer: "formatCurrency",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "تخفیف",
          field: "discount",
          cellRenderer: "formatCurrency",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "جمع اقلام",
          field: "sumItem",
          cellRenderer: "formatCurrency",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "جمع کل",
          field: "sum",
          cellRenderer: "formatCurrency",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "تاریخ",
          field: "createdAt",
          cellRenderer: "formatDateTime",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
      ],
      frameworkComponents: {
        formatCurrency: this.formatCurrency,
        // formatNumber: this.formatNumber,
        fotmatInfoCell: FacturesReportInfo,
        formatString: this.formatString,
        formatDateTime: this.formatDateTime,
        // formatBool: this.formatBool,
      },
      customerReportLoading: true,
      facturesReportLoading: false,
      rowData1: [],
      currentPage1: 1,
      totalPages1: 1,
      facturesReportFilter: [],
      showDetailModal: false,
      currentFactureReportItems: "",
      currentFactureReportDes: "",
      factureIDValue: "",
      factureSearchActionDone: false,
    };

    this.tableGrid = React.createRef();
    this.tableGrid1 = React.createRef();
    this.tableContainer = React.createRef();
    this.tableContainer1 = React.createRef();
    this.chartContainer = React.createRef();
    this.datepicker1 = React.createRef();
    this.datepicker2 = React.createRef();
    this.searchFactureInput = React.createRef();

    this.textHandleChange = this.textHandleChange.bind(this);
    this.reportingSellVolume = this.reportingSellVolume.bind(this);
    this.reportingByPOSType = this.reportingByPOSType.bind(this);
    this.reportingByCategory = this.reportingByCategory.bind(this);
    this.reportingByOrderer = this.reportingByOrderer.bind(this);
    this.reportingByCustomers = this.reportingByCustomers.bind(this);
    this.priceValueFormat = this.priceValueFormat.bind(this);
    this.reportingByProduct = this.reportingByProduct.bind(this);
    this.dateChange1 = this.dateChange1.bind(this);
    this.dateChange2 = this.dateChange2.bind(this);
    this.fixNumber = this.fixNumber.bind(this);

    this.TooltipTemplate1 = this.TooltipTemplate1.bind(this);

    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  formatDateTime(params) {
    try {
      if (
        params.value === "null" ||
        params.value === "" ||
        params.value === 0 ||
        params.value === null
      )
        return "-";
      var zone_name = momentt.tz.guess();
      let newdatetime = momentt
        .tz(params.value, zone_name)
        .format("yyyy-MM-DD HH:mm")
        .toString()
        .split(" ");

      let result =
        newdatetime[1] + " " + moment(newdatetime[0]).format("jYYYY/jMM/jDD");

      return result;
    } catch (error) {
      return "-";
    }
  }

  formatCurrency(params) {
    try {
      if (
        params.value === "null" ||
        params.value === "" ||
        params.value === 0 ||
        params.value === null
      )
        return "-";
      return (
        <NumericFormat
          value={params.value}
          displayType={"text"}
          thousandSeparator={true}
          suffix={" " + this.state.priceUnitValue}
        />
      );
    } catch (error) {
      return "?";
    }
  }

  formatString(params) {
    try {
      if (
        params.value === "null" ||
        params.value === "" ||
        params.value === 0 ||
        params.value === null
      )
        return "-";
      return params.value;
    } catch (error) {
      return "-";
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  showFactureDetails(id) {
    console.log(id);
    let text = "";
    let des = "";

    this.state.rowData1.forEach((element) => {
      if (element.id === id) {
        element.items.forEach((element1) => {
          if (!text) text = element1.foodName + " (" + element1.quantity + ")";
          else
            text = " , " + element1.foodName + " (" + element1.quantity + ")";
        });
        des = element.descr;
      }
    });

    this.setState({
      currentFactureReportItems: text,
      currentFactureReportDes: des,
      showDetailModal: true,
    });
  }

  updateWindowDimensions() {
    try {
      window.setTimeout(() => {
        let widthhh = 0;
        if (window.innerWidth < 1200) {
          widthhh = window.innerWidth - 50;
        } else {
          widthhh = 1150;
        }
        this.setState({
          chartContainerWidth: widthhh,
          chartContainerHeight: this.state.chartData.length * 60,
        });
      }, 100);
    } catch (error) {}
  }

  componentDidMount() {
    // alert(window.innerHeight*0.2)

    var zone_name = momentt.tz.guess();
    this.setState({ ZoneName: zone_name });

    window.addEventListener("resize", this.updateWindowDimensions);
    this.updateWindowDimensions();

    let data = {
      businessCode: this.props.match.params.id,
    };
    // data = Object.assign(data, Authorization());

    fetch(BaseUrlPublic + "findBusinessWithCode", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.status === 200) {
          this.setState(
            {
              resID: result.result[0].id,
              priceUnitValue: result.result[0].rtlPriceTitle,
              defaultLanguage: result.result[0].defaultLanguage,
            },
            () => {
              this.reportingSellVolume();
            }
          );
        } else if (result.status === 401) {
          LogoutFunction();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  onFirstDataRendered(params) {
    try {
      params.api.sizeColumnsToFit();
      window.setTimeout(() => {
        const colIds = params.columnApi.getAllColumns().map((c) => c.colId);
        params.columnApi.autoSizeColumns(colIds, false);

        let cols = this.tableGrid.current.columnApi.getColumnState();
        let width = 0;
        cols.forEach((element) => {
          width += element.width;
        });
        if (
          width <
          this.tableContainer.current.getBoundingClientRect().width - 10
        ) {
          let def =
            this.tableContainer.current.getBoundingClientRect().width -
            10 -
            width;
          if (def > cols.length) {
            let newwidth = def / cols.length;
            cols.forEach((element) => {
              params.columnApi.setColumnWidth(
                element.colId,
                element.width + newwidth
              );
            });
          } else {
            params.columnApi.setColumnWidth(cols[0].colId, cols[0].width + def);
          }
        }
      }, 50);
    } catch (error) {}
  }

  onFirstDataRendered1(params) {
    try {
      params.api.sizeColumnsToFit();
      window.setTimeout(() => {
        const colIds = params.columnApi.getAllColumns().map((c) => c.colId);
        params.columnApi.autoSizeColumns(colIds, false);

        let cols = this.tableGrid1.current.columnApi.getColumnState();
        let width = 0;
        cols.forEach((element) => {
          width += element.width;
        });
        if (
          width <
          this.tableContainer1.current.getBoundingClientRect().width - 10
        ) {
          let def =
            this.tableContainer1.current.getBoundingClientRect().width -
            10 -
            width;
          if (def > cols.length) {
            let newwidth = def / cols.length;
            cols.forEach((element) => {
              params.columnApi.setColumnWidth(
                element.colId,
                element.width + newwidth
              );
            });
          } else {
            params.columnApi.setColumnWidth(cols[0].colId, cols[0].width + def);
          }
        }
      }, 50);
    } catch (error) {}
  }

  reportingSellVolume() {
    let data = {
      businessId: this.state.resID,
      timeZone: this.state.ZoneName,
      pastCount: this.state.sellReportCount,
      mode: this.state.sellReportMode.toString().toLowerCase(),
      calendar: "solar",
    };

    if (this.state.sellReportMode.toString().toLowerCase() === "weekly") {
      data = {
        businessId: this.state.resID,
        timeZone: this.state.ZoneName,
        pastCount: this.state.sellReportCount,
        mode: this.state.sellReportMode.toString().toLowerCase(),
        firstDayOfWeek: 6,
        calendar: "solar",
      };
    }

    if (
      this.state.sellReportMode.toString().toLowerCase() === "monthly" ||
      this.state.sellReportMode.toString().toLowerCase() === "yearly"
    ) {
      data = {
        businessId: this.state.resID,
        timeZone: this.state.ZoneName,
        pastCount: this.state.sellReportCount,
        mode: this.state.sellReportMode.toString().toLowerCase(),
        calendar: "solar",
      };
    }

    data = Object.assign(data, Authorization());
    data = Object.assign(data, { businessCode: this.props.match.params.id });

    fetch(BaseUrl + "reportingSellVolume", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result.result);
        if (result.status === 200) {
          this.setState({
            chartData: result.result,
            dataLoading: false,
            chartContainerHeight: result.result.length * 60,
            currentValueField: "sum",
            currentArgumentField: "date",
          });
        } else if (result.status === 401) {
          LogoutFunction();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  reportingByPOSType() {
    // let date1=moment(this.state.dateValue1).format('YYYY/MM/DD');
    // let date2=moment(this.state.dateValue2).format('YYYY/MM/DD');

    let date1 = moment(this.state.dateValue1, "jYYYY/jMM/jDD").format(
      "YYYY-MM-DD"
    );
    let date2 = moment(this.state.dateValue2, "jYYYY/jMM/jDD").format(
      "YYYY-MM-DD"
    );

    // alert(date1)
    // alert(date2)
    // return

    // let date1=this.state.dateValue1.toString().replace(/[/]/g, "-");
    // let date2=this.state.dateValue2.toString().replace(/[/]/g, "-");

    let data = {
      businessId: this.state.resID,
      businessCode: this.props.match.params.id,
      timeZone: this.state.ZoneName,
      startDate: date1,
      endDate: date2,
    };

    data = Object.assign(data, Authorization());

    fetch(BaseUrl + "reportingByPOSType", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        this.setState({
          chartData: result.result,
          dataLoading: false,
          chartContainerHeight: result.result.length * 60,
          currentValueField: "sum",
          currentArgumentField: "title",
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  reportingByCategory() {
    // let date1=this.state.dateValue1.toString().replace(/[/]/g, "-");
    // let date2=this.state.dateValue2.toString().replace(/[/]/g, "-");
    let date1 = moment(this.state.dateValue1, "jYYYY/jMM/jDD").format(
      "YYYY-MM-DD"
    );
    let date2 = moment(this.state.dateValue2, "jYYYY/jMM/jDD").format(
      "YYYY-MM-DD"
    );

    let data = {
      businessId: this.state.resID,
      businessCode: this.props.match.params.id,
      languageId: 1,
      timeZone: this.state.ZoneName,
      startDate: date1,
      endDate: date2,
      otherFilters: [],
    };

    data = Object.assign(data, Authorization());

    fetch(BaseUrl + "reportingByCategory", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        this.setState({ report2Data: result.result, dataLoading: false });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  reportingByProduct() {
    // let date1=this.state.dateValue1.toString().replace(/[/]/g, "-");
    // let date2=this.state.dateValue2.toString().replace(/[/]/g, "-");
    let date1 = moment(this.state.dateValue1, "jYYYY/jMM/jDD").format(
      "YYYY-MM-DD"
    );
    let date2 = moment(this.state.dateValue2, "jYYYY/jMM/jDD").format(
      "YYYY-MM-DD"
    );

    let data = {
      businessId: this.state.resID,
      businessCode: this.props.match.params.id,
      languageId: 1,
      timeZone: this.state.ZoneName,
      startDate: date1,
      endDate: date2,
      otherFilters: [],
    };

    data = Object.assign(data, Authorization());

    fetch(BaseUrl + "reportingByProduct", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        this.setState({
          chartData: result.result,
          dataLoading: false,
          chartContainerHeight: result.result.length * 60,
          currentValueField: "totalSell",
          currentArgumentField: "foodName",
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  reportingByOrderer() {
    let date1 = moment(this.state.dateValue1, "jYYYY/jMM/jDD").format(
      "YYYY-MM-DD"
    );
    let date2 = moment(this.state.dateValue2, "jYYYY/jMM/jDD").format(
      "YYYY-MM-DD"
    );

    let data = {
      businessId: this.state.resID,
      businessCode: this.props.match.params.id,
      timeZone: this.state.ZoneName,
      startDate: date1,
      endDate: date2,
      otherFilters: [],
    };

    data = Object.assign(data, Authorization());

    fetch(BaseUrl + "reportingByOrderer", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        let temp = result.result;
        temp.forEach((element) => {
          if (element.userName) element.orderer = element.userName;
        });
        this.setState({
          chartData: temp,
          dataLoading: false,
          chartContainerHeight: temp.length * 60,
          currentValueField: "SUM(O.sum)",
          currentArgumentField: "orderer",
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  reportingByCustomers(page, excel) {
    let date1 = moment(this.state.dateValue1, "jYYYY/jMM/jDD").format(
      "YYYY-MM-DD"
    );
    let date2 = moment(this.state.dateValue2, "jYYYY/jMM/jDD").format(
      "YYYY-MM-DD"
    );

    let data = {
      businessId: this.state.resID,
      businessCode: this.props.match.params.id,
      timeZone: this.state.ZoneName,
      startDate: date1,
      endDate: date2,
      otherFilters: [],
      getExcel: excel,
      paginate: !excel
        ? {
            page: page,
            count: 15,
          }
        : null,
    };

    data = Object.assign(data, Authorization());
    if (!excel) this.setState({ customerReportLoading: true });
    console.log(data);
    if (!excel) {
      fetch(BaseUrl + "reportingByCustomers", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((result) => {
          console.log(result);
          this.setState({
            rowData: result.result,
            customerReportLoading: false,
            totalPages: result.totalPage,
            currentPage: page,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      fetch(BaseUrl + "reportingByCustomers", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((res) => res.body)
        .then((stream) => new Response(stream))
        .then((response) => response.blob())
        .then((blob) => URL.createObjectURL(blob))
        .then((url) => {
          const link = document.createElement("a");
          link.href = url;
          link.download =
            "SepandPlus_CR_" +
            moment(this.state.dateValue1, "jYYYY/jMM/jDD").format(
              "jYYYY-jMM-jDD"
            ) +
            "_" +
            moment(this.state.dateValue2, "jYYYY/jMM/jDD").format(
              "jYYYY-jMM-jDD"
            ) +
            ".xlsx";
          document.body.appendChild(link);
          link.dispatchEvent(
            new MouseEvent("click", {
              bubbles: true,
              cancelable: true,
              view: window,
            })
          );
          document.body.removeChild(link);
        })
        .catch((err) => {
          toast.error(err.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        });
    }
  }

  onBack() {
    this.props.history.push("/Restaurants/" + this.props.match.params.id);
  }

  onLogout() {
    LogoutFunction();
  }

  hideModal() {
    this.setState({ ModalShow: false });
  }

  textHandleChange(e) {
    this.setState({ [e.target.name]: e.target.value }, () => {
      this.reportingSellVolume();
    });
  }

  priceValueFormat(params) {
    try {
      let result =
        params.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
        "‌" +
        this.state.priceUnitValue;
      // let result=params.value.toString()+" عدد ("+params.point.data.amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") +" ریال) ("+params.percentText.toString()+")"
      return result;
    } catch (error) {
      return "-";
    }
  }

  onFilterClick() {
    this.setState({ ModalShow: true });
  }

  reportChangeClick(id) {
    this.setState({ reportSelected: id }, () => {
      switch (id) {
        case 0: {
          this.reportingSellVolume();
          break;
        }
        case 1: {
          this.reportingByPOSType();
          break;
        }
        case 2: {
          this.reportingByCategory();
          break;
        }
        case 3: {
          this.reportingByProduct();
          break;
        }
        case 4: {
          this.reportingByOrderer();
          break;
        }
        case 5: {
          this.reportingByCustomers(1, false);
          break;
        }
        case 6: {
          this.setState({ factureSearchActionDone: false }, () => {
            this.findAllOrder(1, false);
          });

          break;
        }
        default:
          break;
      }
    });
  }

  findAllOrder(page, excel) {
    let data;

    let date1 = moment(this.state.dateValue1, "jYYYY/jMM/jDD").format(
      "YYYY-MM-DD"
    );
    let date2 = moment(this.state.dateValue2, "jYYYY/jMM/jDD").format(
      "YYYY-MM-DD"
    );

    let filter = [
      {
        title: "date",
        params: {
          startDate: date1,
          endDate: date2,
          timeZone: this.state.ZoneName,
        },
      },
    ];

    if (!excel)
      filter.push({ title: "paginate", params: { page: page, count: 15 } });

    if (this.state.factureSearchActionDone) {
      filter.push({
        title: "search",
        params: { value: this.searchFactureInput.current.value },
      });
    }

    // startDate: date1,
    // endDate: date2,

    data = {
      languageId: this.state.defaultLanguage,
      businessId: this.state.resID,
      status: 2,
      lastCreated: null,
      filter: filter,
      getExcel: excel,
    };

    data = Object.assign(data, Authorization());
    data = Object.assign(data, { businessCode: this.props.match.params.id });

    console.log("data", data);

    if (!excel) this.setState({ facturesReportLoading: true });
    console.log(data);
    if (!excel) {
      fetch(BaseUrl + "findAllOrder", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((result) => {
          console.log(result);
          if (result.status === 200) {
            this.setState({
              facturesReportLoading: false,
              rowData1: result.result,
              currentPage1: page,
              totalPages1: Math.ceil(result.totalItem / 15),
            });
          } else if (result.status === 401) {
            LogoutFunction();
          }
        })
        .catch((err) => {
          console.log(err);
          this.setState({ dataLoading: false });
        });
    } else {
      fetch(BaseUrl + "findAllOrder", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((res) => res.body)
        .then((stream) => new Response(stream))
        .then((response) => response.blob())
        .then((blob) => URL.createObjectURL(blob))
        .then((url) => {
          const link = document.createElement("a");
          link.href = url;
          link.download =
            "SepandPlus_FR_" +
            moment(this.state.dateValue1, "jYYYY/jMM/jDD").format(
              "jYYYY-jMM-jDD"
            ) +
            "_" +
            moment(this.state.dateValue2, "jYYYY/jMM/jDD").format(
              "jYYYY-jMM-jDD"
            ) +
            ".xlsx";
          document.body.appendChild(link);
          link.dispatchEvent(
            new MouseEvent("click", {
              bubbles: true,
              cancelable: true,
              view: window,
            })
          );
          document.body.removeChild(link);
        })
        .catch((err) => {
          toast.error(err.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        });
    }
  }

  TooltipTemplate1(params) {
    return {
      text: `Count: ${params.point.data.count}       Average: ${params.point.data.average}`,
    };
  }

  TooltipTemplate3(params) {
    return {
      text: `Quantity: ${params.point.data.totalQuantity}`,
    };
  }

  fixNumber(str) {
    var persianNumbers = [
        /۰/g,
        /۱/g,
        /۲/g,
        /۳/g,
        /۴/g,
        /۵/g,
        /۶/g,
        /۷/g,
        /۸/g,
        /۹/g,
      ],
      arabicNumbers = [
        /٠/g,
        /١/g,
        /٢/g,
        /٣/g,
        /٤/g,
        /٥/g,
        /٦/g,
        /٧/g,
        /٨/g,
        /٩/g,
      ];
    if (typeof str === "string") {
      for (var i = 0; i < 10; i++) {
        str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
      }
    }
    return str;
  }

  dateChange1(dateValue) {
    console.log("dateValue1: ", dateValue);
    try {
      this.datepicker1.current.closeCalendar();
      this.datepicker2.current.closeCalendar();
    } catch (error) {}
    console.log(dateValue);
    let value = this.fixNumber(new DateObject(dateValue).format("YYYY/MM/DD"));
    console.log(value);
    this.setState({ dateValue1: value, minDate: value }, () => {
      switch (this.state.reportSelected) {
        case 1: {
          this.reportingByPOSType();
          break;
        }
        case 2: {
          this.reportingByCategory();
          break;
        }
        case 3: {
          this.reportingByProduct();
          break;
        }
        case 4: {
          this.reportingByOrderer();
          break;
        }
        case 5: {
          this.reportingByCustomers(1, false);
          break;
        }
        case 6: {
          this.findAllOrder(1, false);
          break;
        }
        default:
          break;
      }
    });
  }

  dateChange2(dateValue) {
    try {
      this.datepicker1.current.closeCalendar();
      this.datepicker2.current.closeCalendar();
    } catch (error) {}

    console.log(dateValue);
    let value = this.fixNumber(new DateObject(dateValue).format("YYYY/MM/DD"));
    this.setState({ dateValue2: value }, () => {
      switch (this.state.reportSelected) {
        case 1: {
          this.reportingByPOSType();
          break;
        }
        case 2: {
          this.reportingByCategory();
          break;
        }
        case 3: {
          this.reportingByProduct();
          break;
        }
        case 4: {
          this.reportingByOrderer();
          break;
        }
        case 5: {
          this.reportingByCustomers(1, false);
          break;
        }
        case 6: {
          this.findAllOrder(1, false);
          break;
        }
        default:
          break;
      }
    });
  }

  onProfile() {
    this.setState({ ModalShow: true });
  }

  // reportingByCustomers(page) {}

  onFirstPageClick() {
    this.reportingByCustomers(1, false);
  }

  onPreviousPageClick() {
    this.reportingByCustomers(this.state.currentPage - 1, false);
  }

  onNextPageClick() {
    this.reportingByCustomers(this.state.currentPage + 1, false);
  }

  onLastPageClick() {
    this.reportingByCustomers(this.state.totalPages, false);
  }

  onFirstPageClick1() {
    this.findAllOrder(1, false);
  }

  onPreviousPageClick1() {
    this.findAllOrder(this.state.currentPage1 - 1, false);
  }

  onNextPageClick1() {
    console.log(this.state.currentPage1);
    this.findAllOrder(this.state.currentPage1 + 1, false);
  }

  onLastPageClick1() {
    this.findAllOrder(this.state.totalPages1, false);
  }

  render() {
    return (
      <div className="Login">
        <div className="header">
          <div
            onClick={this.onBack.bind(this)}
            className="linkStyle backButton"
          >
            <img
              src={Back}
              alt=""
              className="backButtonIcon"
              style={{ transform: "rotate(180deg)" }}
            />
            بازگشت
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              height: "fit-content",
              alignItems: "center",
            }}
          >
            <Tooltip title="اطلاعات کاربری">
              <div
                onClick={this.onProfile.bind(this)}
                className="linkStyle backButton"
                // data-tip="اطلاعات کاربری"
                // data-place="right"
              >
                <img src={Profilee} alt="" className="backButtonIcon" />
              </div>
            </Tooltip>
            <div
              style={{
                height: "20px",
                minWidth: "1px",
                backgroundColor: "var(--brown1)",
                margin: "0px 5px",
              }}
            />
            <Tooltip title="خروج">
              <div
                onClick={this.onLogout.bind(this)}
                className="linkStyle backButton"
                // data-tip="خروج"
                // data-place="bottom"
              >
                <img src={Logout} alt="" className="backButtonIcon" />
              </div>
            </Tooltip>
          </div>
        </div>
        <div className="LoginContent">
          <div className="RestaurantsListTitle">گزارشات</div>
          {/* <div className="RestaurantsListSubTitle"></div> */}
          {/* <div className="RestaurantsListSubTitle">گزارش مالی و لیست مشترکین رستوران</div> */}
        </div>
        {this.state.dataLoading && (
          <div
            style={{
              display: "flex",
              width: "100vw",
              maxWidth: "1200px",
              height: "75vh",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <WhisperSpinner
              size={50}
              color="var(--brown1)"
              frontColor="var(--brown1)"
              backColor="var(--brown1)"
              loading={true}
            />
          </div>
        )}
        {!this.state.dataLoading && (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              flexWrap: "wrap",
              width: "100%",
              maxWidth: "1200px",
            }}
          >
            <div
              className="reportButton"
              onClick={this.reportChangeClick.bind(this, 0)}
              style={{
                backgroundColor:
                  this.state.reportSelected === 0 ? "#d6783a3a" : "transparent",
                borderColor:
                  this.state.reportSelected === 0
                    ? "var(--brown1)"
                    : "var(--brown3)",
              }}
            >
              فروش کلی
            </div>

            <div
              className="reportButton"
              onClick={this.reportChangeClick.bind(this, 1)}
              style={{
                backgroundColor:
                  this.state.reportSelected === 1 ? "#d6783a5d" : "transparent",
                borderColor:
                  this.state.reportSelected === 1
                    ? "var(--brown1)"
                    : "var(--brown3)",
              }}
            >
              فروش به تفکیک ایستگاه‌ها
            </div>

            <div
              className="reportButton"
              onClick={this.reportChangeClick.bind(this, 2)}
              style={{
                backgroundColor:
                  this.state.reportSelected === 2 ? "#d6783a5d" : "transparent",
                borderColor:
                  this.state.reportSelected === 2
                    ? "var(--brown1)"
                    : "var(--brown3)",
              }}
            >
              فروش به تفکیک دسته‌ها
            </div>

            <div
              className="reportButton"
              onClick={this.reportChangeClick.bind(this, 3)}
              style={{
                backgroundColor:
                  this.state.reportSelected === 3 ? "#d6783a5d" : "transparent",
                borderColor:
                  this.state.reportSelected === 3
                    ? "var(--brown1)"
                    : "var(--brown3)",
              }}
            >
              فروش به تفکیک محصولات
            </div>

            <div
              className="reportButton"
              onClick={this.reportChangeClick.bind(this, 4)}
              style={{
                backgroundColor:
                  this.state.reportSelected === 4 ? "#d6783a5d" : "transparent",
                borderColor:
                  this.state.reportSelected === 4
                    ? "var(--brown1)"
                    : "var(--brown3)",
              }}
            >
              فروش به تفکیک کاربران
            </div>

            <div
              className="reportButton"
              onClick={this.reportChangeClick.bind(this, 5)}
              style={{
                backgroundColor:
                  this.state.reportSelected === 5 ? "#d6783a5d" : "transparent",
                borderColor:
                  this.state.reportSelected === 5
                    ? "var(--brown1)"
                    : "var(--brown3)",
              }}
            >
              فروش به تفکیک مشتریان
            </div>

            <div
              className="reportButton"
              onClick={this.reportChangeClick.bind(this, 6)}
              style={{
                backgroundColor:
                  this.state.reportSelected === 6 ? "#d6783a5d" : "transparent",
                borderColor:
                  this.state.reportSelected === 6
                    ? "var(--brown1)"
                    : "var(--brown3)",
              }}
            >
              گزارش فاکتورها
            </div>
          </div>
        )}
        <div
          className="reportContaner"
          style={{ display: this.state.dataLoading ? "none" : "flex" }}
        >
          {this.state.reportSelected === 0 && (
            <div className="reportTitleBar">فروش کلی</div>
          )}
          {this.state.reportSelected === 1 && (
            <div className="reportTitleBar">فروش به تفکیک ایستگاه‌ها</div>
          )}
          {this.state.reportSelected === 2 && (
            <div className="reportTitleBar">فروش به تفکیک دسته‌ها</div>
          )}
          {this.state.reportSelected === 3 && (
            <div className="reportTitleBar">فروش به تفکیک محصولات</div>
          )}
          {this.state.reportSelected === 4 && (
            <div className="reportTitleBar">فروش به تفکیک کاربران</div>
          )}
          {this.state.reportSelected === 5 && (
            <div className="reportTitleBar">فروش به تفکیک مشتریان</div>
          )}

          {this.state.reportSelected === 6 && (
            <div className="reportTitleBar">گزارش فاکتورها</div>
          )}

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              backgroundColor:
                this.state.reportSelected !== 5 &&
                this.state.reportSelected !== 6
                  ? "var(--brown1)"
                  : "var(--gray1)",
            }}
          >
            {this.state.reportSelected === 0 && (
              <div
                style={{
                  maxWidth: "200px",
                  margin: "10px 10px",
                  alignSelf: "flex-start",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <Form.Control
                  value={this.state.sellReportMode}
                  className="inputStyleForm forceFont"
                  style={{ minWidth: "100px" }}
                  name="sellReportMode"
                  onChange={this.textHandleChange.bind(this)}
                  as="select"
                >
                  <option className="forceFont" value="daily">
                    روزانه
                  </option>
                  <option className="forceFont" value="weekly">
                    هفتگی
                  </option>
                  <option className="forceFont" value="monthly">
                    ماهانه
                  </option>
                  <option className="forceFont" value="yearly">
                    سالانه
                  </option>
                </Form.Control>
                <div style={{ minWidth: "10px" }} />
                <Form.Control
                  value={this.state.sellReportCount}
                  className="inputStyleForm forceFont"
                  name="sellReportCount"
                  onChange={this.textHandleChange.bind(this)}
                  as="select"
                >
                  <option className="forceFont">5</option>
                  <option className="forceFont">10</option>
                  <option className="forceFont">15</option>
                  <option className="forceFont">20</option>
                </Form.Control>
              </div>
            )}

            {this.state.reportSelected !== 0 && (
              <div className="reportFilterStyle">
                <div
                  style={{
                    maxWidth: "200px",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <DatePicker
                    ref={this.datepicker1}
                    value={this.state.dateValue1}
                    inputClass="form-control inputStyleFilter"
                    calendar="persian"
                    locale="fa"
                    weekDays={["ش", "ی", "د", "س", "چ", "پ", "ج"]}
                    format="YYYY/MM/DD"
                    animation
                    className="rmdp-mobile bluee"
                    onChange={(valuee) => this.dateChange1(valuee)}
                    maxDate={this.state.maxDateStart}
                    editable={false}
                    inputMode="none"
                    placeholder="شروع"
                  />
                  <div
                    style={{
                      minWidth: "15px",
                      margin: "0px 5px",
                      minHeight: "1px",
                      height: "1px",
                      backgroundColor: "white",
                    }}
                  />

                  <DatePicker
                    ref={this.datepicker2}
                    value={this.state.dateValue2}
                    inputClass="form-control inputStyleFilter"
                    calendar="persian"
                    locale="fa"
                    weekDays={["ش", "ی", "د", "س", "چ", "پ", "ج"]}
                    format="YYYY/MM/DD"
                    animation
                    className="rmdp-mobile bluee"
                    onChange={(valuee) => this.dateChange2(valuee)}
                    minDate={this.state.minDate}
                    maxDate={this.state.maxDate}
                    editable={false}
                    inputMode="none"
                    placeholder="پایان"
                  />
                </div>

                {this.state.reportSelected === 6 && (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <div>
                      <Form.Control
                        // maxLength="50"
                        className="inputStyleForm textAlignCenter"
                        style={{ minWidth: "80px" }}
                        placeholder="شماره فاکتور"
                        type="text"
                        name="factureIDValue"
                        // onChange={(e)=>{
                        //   this.setState({factureIDValue:e.target.value})
                        // }}
                        // value={this.state.factureIDValue}
                        ref={this.searchFactureInput}
                      />
                    </div>
                    <div style={{ marginRight: "10px" }}>
                      <CustomButton
                        // title="خروجی اکسل"
                        // imgHeight={20}
                        // imgWidth={25}
                        flexDirection="row-reverse"
                        minHeight="35px"
                        minWidth="40px"
                        // img={Plus}
                        ico={searchIcon}
                        onClick={() => {
                          if (this.searchFactureInput.current.value)
                            this.setState(
                              { factureSearchActionDone: true },
                              () => {
                                this.findAllOrder(1, false);
                              }
                            );
                        }}
                      />
                    </div>
                    {this.state.factureSearchActionDone && (
                      <div style={{ marginRight: "5px" }}>
                        <CustomButton
                          // title="خروجی اکسل"
                          // imgHeight={20}
                          // imgWidth={25}
                          flexDirection="row-reverse"
                          minHeight="35px"
                          minWidth="40px"
                          backColor="var(--red1)"
                          // img={Plus}
                          ico={baselineClose}
                          onClick={() => {
                            this.setState(
                              { factureSearchActionDone: false },
                              () => {
                                this.searchFactureInput.current.value = "";
                                this.findAllOrder(1, false);
                              }
                            );
                          }}
                        />
                      </div>
                    )}
                  </div>
                )}
                {(this.state.reportSelected === 5 ||
                  this.state.reportSelected === 6) && (
                  <div>
                    <CustomButton
                      title="خروجی اکسل"
                      imgHeight={20}
                      imgWidth={25}
                      flexDirection="row-reverse"
                      minHeight="35px"
                      // img={Plus}
                      ico={fileExcel}
                      onClick={() => {
                        if (this.state.reportSelected === 5)
                          this.reportingByCustomers(1, true);
                        else if (this.state.reportSelected === 6)
                          this.findAllOrder(1, true);
                      }}
                    />
                  </div>
                )}
              </div>
            )}

            <div
              className="reportContent"
              style={{
                backgroundColor:
                  this.state.reportSelected !== 5 &&
                  this.state.reportSelected !== 6
                    ? "var(--brown1)"
                    : "var(--gray1)",
                alignItems: "stretch",
              }}
            >
              <div
                ref={this.chartContainer}
                style={{
                  flex: "1",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding:
                    this.state.reportSelected !== 5 &&
                    this.state.reportSelected !== 6
                      ? "20px"
                      : "0px",
                }}
              >
                {this.state.reportSelected !== 2 &&
                  this.state.reportSelected !== 5 &&
                  this.state.reportSelected !== 6 &&
                  this.state.chartData.length > 0 && (
                    <Chart
                      id="chart"
                      dataSource={this.state.chartData}
                      rotated={true}
                      rtlEnabled
                    >
                      <Series
                        valueField={this.state.currentValueField}
                        argumentField={this.state.currentArgumentField}
                        type="bar"
                        color="#fff"
                      >
                        <Label
                          visible={true}
                          customizeText={this.priceValueFormat}
                        >
                          <Font
                            color="var(--brown1)"
                            family="SFUIDisplay"
                            size={14}
                          />
                        </Label>
                      </Series>

                      <ArgumentAxis color="white">
                        <Tick visible={true} color="white" />
                        <MinorTick visible={true} color="white" />
                        <Label>
                          <Font color="white" family="SFUIDisplay" size={14} />
                        </Label>
                      </ArgumentAxis>

                      <ValueAxis color="white">
                        <Tick visible={true} color="white" />
                        <MinorTick visible={true} color="white" />
                        <Label>
                          <Font color="white" family="SFUIDisplay" size={14} />
                        </Label>
                      </ValueAxis>
                      {this.state.reportSelected === 1 && (
                        <ChartTooltip
                          enabled={true}
                          customizeTooltip={this.TooltipTemplate1}
                        />
                      )}
                      {this.state.reportSelected === 3 && (
                        <ChartTooltip
                          enabled={true}
                          customizeTooltip={this.TooltipTemplate3}
                        />
                      )}
                      <Legend visible={false} />
                      <Size
                        width={this.state.chartContainerWidth}
                        height={this.state.chartContainerHeight}
                      />
                    </Chart>
                  )}

                {this.state.reportSelected === 2 &&
                  this.state.report2Data.length > 0 && (
                    <Accordion
                      style={{
                        width: "100%",
                      }}
                    >
                      {this.state.report2Data.map((item, i) => {
                        return (
                          <Card key={i}>
                            <Accordion.Toggle as={Card.Header} eventKey={i + 1}>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  width: "100%",
                                  textAlign: "start",
                                }}
                              >
                                <div style={{ flex: "1" }}>
                                  {item.CategoryName}
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    flex: "1",
                                    justifyContent: "center",
                                  }}
                                >
                                  {item.totalQuantity}
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    flex: "1",
                                    justifyContent: "flex-end",
                                  }}
                                >
                                  <NumericFormat
                                    allowNegative={true}
                                    value={item.totalSell}
                                    displayType={"text"}
                                    thousandSeparator={true}
                                    suffix={"‌" + this.state.priceUnitValue}
                                  />
                                </div>
                              </div>
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={i + 1}>
                              <Card.Body
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                {item.items.map((item1, ii) => {
                                  return (
                                    <div
                                      style={{
                                        width: "100%",
                                        display: "flex",
                                        flexDirection: "column",
                                      }}
                                      key={ii}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "row",
                                          width: "100%",
                                        }}
                                      >
                                        <div
                                          style={{
                                            flex: "1",
                                            textAlign: "right",
                                          }}
                                        >
                                          {item1.foodName}
                                        </div>
                                        <div
                                          style={{
                                            display: "flex",
                                            flex: "1",
                                            justifyContent: "center",
                                          }}
                                        >
                                          {item1.totalQuantity}
                                        </div>
                                        {/* <div style={{display:'flex',flex:'1',justifyContent:'flex-end'}}>{item1.totalSell}&nbsp;{this.state.priceUnitValue}</div> */}
                                        <div
                                          style={{
                                            display: "flex",
                                            flex: "1",
                                            justifyContent: "flex-end",
                                          }}
                                        >
                                          <NumericFormat
                                            allowNegative={true}
                                            value={item1.totalSell}
                                            displayType={"text"}
                                            thousandSeparator={true}
                                            suffix={
                                              "‌" + this.state.priceUnitValue
                                            }
                                          />
                                        </div>
                                      </div>

                                      <div
                                        style={{
                                          minHeight: "1px",
                                          backgroundColor: "var(--gray1)",
                                          width: "100%",
                                          margin: "10px 0px",
                                        }}
                                      />
                                    </div>
                                  );
                                })}
                              </Card.Body>
                            </Accordion.Collapse>
                          </Card>
                        );
                      })}
                    </Accordion>
                    // </div>
                  )}

                {this.state.reportSelected === 5 && (
                  <div
                    className="pageContents"
                    style={{ marginTop: "0px" }}
                    ref={this.tableContainer}
                  >
                    {!this.state.customerReportLoading && (
                      <div className="tableContainer ag-theme-alpine">
                        <AgGridReact
                          enableRtl={true}
                          autoHeight={true}
                          animateRows={true}
                          enableBrowserTooltips={true}
                          tooltipMouseTrack={true}
                          suppressSizeToFit={false}
                          columnDefs={this.state.columnDefs}
                          localeText={this.state.gridLocaleText}
                          rowData={this.state.rowData}
                          suppressDragLeaveHidesColumns={true}
                          suppressMovable={true}
                          skipHeaderOnAutoSize={false}
                          // onGridReady={this.onGridReady.bind(this)}
                          onFirstDataRendered={this.onFirstDataRendered.bind(
                            this
                          )}
                          rowHeight={window.innerWidth <= 587 ? 40 : 50}
                          headerHeight={window.innerWidth <= 587 ? 40 : 50}
                          frameworkComponents={this.state.frameworkComponents}
                          // onRowClicked={this.onGridRowClicked.bind(this)}
                          // getRowStyle ={function(params){ return { borderWidth:'0px' }}}
                          ref={this.tableGrid}
                          enableCellTextSelection={true}
                          ensureDomOrder={true}
                        />
                      </div>
                    )}
                    {!this.state.customerReportLoading && (
                      <div
                        style={{
                          width: "100%",
                          margin: "15px 0px",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <Paginator
                          currentPage={this.state.currentPage}
                          totalPages={this.state.totalPages}
                          onFirstPageClick={this.onFirstPageClick.bind(this)}
                          onPreviousPageClick={this.onPreviousPageClick.bind(
                            this
                          )}
                          onNextPageClick={this.onNextPageClick.bind(this)}
                          onLastPageClick={this.onLastPageClick.bind(this)}
                        />
                      </div>
                    )}

                    {this.state.customerReportLoading && (
                      <div
                        style={{
                          display: "flex",
                          width: "100%",
                          height: "100%",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <WhisperSpinner
                          size={50}
                          color="var(--brown1)"
                          frontColor="var(--brown1)"
                          backColor="var(--brown1)"
                          loading={true}
                        />
                      </div>
                    )}
                  </div>
                )}

                {this.state.reportSelected === 6 && (
                  <div
                    className="pageContents"
                    style={{ marginTop: "0px" }}
                    ref={this.tableContainer1}
                  >
                    {!this.state.facturesReportLoading && (
                      <div className="tableContainer ag-theme-alpine">
                        <AgGridReact
                          enableRtl={true}
                          autoHeight={true}
                          animateRows={true}
                          enableBrowserTooltips={true}
                          tooltipMouseTrack={true}
                          suppressSizeToFit={false}
                          columnDefs={this.state.columnDefs1}
                          localeText={this.state.gridLocaleText}
                          rowData={this.state.rowData1}
                          suppressDragLeaveHidesColumns={true}
                          suppressMovable={true}
                          skipHeaderOnAutoSize={false}
                          // onGridReady={this.onGridReady.bind(this)}
                          onFirstDataRendered={this.onFirstDataRendered1.bind(
                            this
                          )}
                          rowHeight={window.innerWidth <= 587 ? 40 : 50}
                          headerHeight={window.innerWidth <= 587 ? 40 : 50}
                          frameworkComponents={this.state.frameworkComponents}
                          // onRowClicked={this.onGridRowClicked.bind(this)}
                          // getRowStyle ={function(params){ return { borderWidth:'0px' }}}
                          ref={this.tableGrid1}
                          enableCellTextSelection={true}
                          ensureDomOrder={true}
                        />
                      </div>
                    )}
                    {!this.state.facturesReportLoading && (
                      <div
                        style={{
                          width: "100%",
                          margin: "15px 0px",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <Paginator
                          currentPage={this.state.currentPage1}
                          totalPages={this.state.totalPages1}
                          onFirstPageClick={this.onFirstPageClick1.bind(this)}
                          onPreviousPageClick={this.onPreviousPageClick1.bind(
                            this
                          )}
                          onNextPageClick={this.onNextPageClick1.bind(this)}
                          onLastPageClick={this.onLastPageClick1.bind(this)}
                        />
                      </div>
                    )}

                    {this.state.facturesReportLoading && (
                      <div
                        style={{
                          display: "flex",
                          width: "100%",
                          height: "100%",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <WhisperSpinner
                          size={50}
                          color="var(--brown1)"
                          frontColor="var(--brown1)"
                          backColor="var(--brown1)"
                          loading={true}
                        />
                      </div>
                    )}
                  </div>
                )}

                {((this.state.reportSelected === 2 &&
                  this.state.report2Data.length === 0) ||
                  (this.state.reportSelected !== 2 &&
                    this.state.reportSelected !== 5 &&
                    this.state.chartData.length === 0)) && (
                  <div
                    style={{
                      width: "100%",
                      minHeight: "200px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      color: "rgba(255,255,255,0.7)",
                    }}
                  >
                    در بازه زمانی مورد نظر اطلاعاتی یافت نشد
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <Modal
          show={this.state.ModalShow}
          animation={false}
          onHide={this.hideModal.bind(this)}
          centered
        >
          <Profile
            businessCode={this.props.match.params.id}
            hideModal={this.hideModal.bind(this)}
          />
        </Modal>

        <Modal
          show={this.state.showDetailModal}
          animation={false}
          onHide={() => {
            this.setState({ showDetailModal: false });
          }}
          centered
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              padding: "20px",
            }}
          >
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div style={{ marginLeft: "10px" }}>سفارشات: </div>
              <div>{this.state.currentFactureReportItems}</div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginTop: "20px",
              }}
            >
              <div style={{ marginLeft: "10px" }}>توضیحات: </div>
              <div>
                {this.state.currentFactureReportDes
                  ? this.state.currentFactureReportDes
                  : "-"}
              </div>
            </div>
            <div style={{ minHeight: "20px" }} />
            <CustomButton
              title="بستن"
              imgHeight={20}
              imgWidth={25}
              flexDirection="row-reverse"
              onClick={() => {
                this.setState({ showDetailModal: false });
              }}
            />
          </div>
        </Modal>
      </div>
    );
  }
}
